// extracted by mini-css-extract-plugin
export default {"div":"Favorite_div__+XW2E","noFavoriteCards":"Favorite_noFavoriteCards__qlPzj","favorite":"Favorite_favorite__lRZMO"};